import { HStack, Text, Badge, VStack } from '@chakra-ui/react'
import type { TrafficLightColor as TrafficLightStatusType } from '../types'

interface TrafficLightStatusProps {
  status: TrafficLightStatusType
  reason?: string
  showDescription?: boolean
}

const STATUS_CONFIG: Record<
  TrafficLightStatusType,
  {
    label: string
    colorPalette: 'green' | 'yellow' | 'red' | 'gray'
    description: string
  }
> = {
  green: {
    label: 'Capacity fits',
    colorPalette: 'green',
    description: "The SIB's available capacity matches the demand well.",
  },
  yellow: {
    label: 'Capacity tight',
    colorPalette: 'yellow',
    description: 'The SIB may be able to fulfill the demand, but capacity is limited.',
  },
  red: {
    label: 'Strongly exceeded',
    colorPalette: 'red',
    description: 'The SIB currently has insufficient capacity for this demand.',
  },
  unknown: {
    label: 'Unknown',
    colorPalette: 'gray',
    description: 'No matching information is available.',
  },
}

export function TrafficLightStatus({
  status,
  reason,
  showDescription = false,
}: TrafficLightStatusProps) {
  const config = STATUS_CONFIG[status]

  return (
    <VStack align="start" gap={1}>
      <HStack>
        <Badge
          colorPalette={config.colorPalette}
          borderRadius="full"
          px={2}
          py={1}
          fontWeight="medium"
        >
          {config.label}
        </Badge>
      </HStack>

      {showDescription && (
        <Text fontSize="sm" color="fg.muted">
          {reason ?? config.description}
        </Text>
      )}
    </VStack>
  )
}
